<!-- 绑定手机弹层 -->
<template>
   <div id="share" v-if="shareState">
		 <bv-bind-phone
			 :spacial="{state:true}"
			 :show-bind-phone-status="true"
			  @close-bind-phone="closeBindPhoneShare"/>
	 </div>
</template>

<script>
  import store from '@store';

  export default {
    name: "bind-phone-share",
    props: {
      //显示的状态，props设置为false是时候适用于点击判断带入状态来显示绑定手机号
      showBindPhoneStatus: {
        default: true,
        type: Boolean
      }
    },
    computed: {
      //是否显示绑定手机
			shareState(){
        return store.state.shareState;
			},
    },
    methods:{
      closeBindPhoneShare() {
        this.$emit('close-bind-phone');
      },
			show(){
        store.state.shareState = true;
			},
			hide(){
        store.state.shareState = false;
			}
		}
  }
</script>
